module.exports = __webpack_public_path__ + "img/bg-md-2x.083dea9.jpg";